<script>
  import _ from 'lodash';

  export default ({
    name: 'v-form-followup',

    props: {
      refFormNames: {
        type: Array,
        default: () => ['form_rh_c1_followup.email']
      },
      refFormUrl: {
        type: String,
        default: '/lp/entry/input/followup/execute/',
      },
    },

    data() {
      return {
        sending: false,
        formNames: this.refFormNames,
        formUrl: this.refFormUrl
      };
    },

    methods: {
      submitCheckValidate(event) {
        this.sending = true;

        this._checkValidate()
          .then(() => {
            event.target.submit();
          })
          .catch(() => {
            this.sending = false;
          });
      },

      /**
       * 指定したキーの値がバリデーションをパスしているかどうか
       *
       * @returns {boolean}
       */
      isValidatePasses(key) {
        return this.$store.getters.getIsPassValidateByKey(key, false);
      },

      /**
       * 現在のステップ内のフォーム値にエラーが存在するかどうか
       *
       * @returns {boolean}
       */
      isPassValidateInForms() {
        let isPassValidate = true;

        _.forEach(this.formNames, (formName) => {
          if (!this.isValidatePasses(formName)) {
            isPassValidate = false;
          }
        });

        return isPassValidate;
      },

      /**
       * 全体のバリデーションをチェックする
       * @private
       */
      _checkValidate() {
        {
          return this.$store.dispatch('validate', {data: this.getValidateValues(this.formNames), path: this.formUrl});
        }
      },

      /**
       * バリデーション用の値を取得
       *
       * @returns {Object}
       */
      getValidateValues(formNames) {
        const validateValues = {};

        _.forEach(formNames, (formName) => {
          validateValues[formName] = this.$store.getters.getValueByKey(formName,
            null);
        });

        return validateValues;
      },
    },
  });
</script>
